import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ArrowRight } from '@jsluna/icons';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Card = function Card(_ref) {
  var _classnames;

  var element = _ref.element,
      className = _ref.className,
      hard = _ref.hard,
      children = _ref.children,
      color = _ref.color,
      rounded = _ref.rounded,
      rest = _objectWithoutPropertiesLoose(_ref, ["element", "className", "hard", "children", "color", "rounded"]);

  var Element = element;
  return /*#__PURE__*/React.createElement(Element, _extends({}, rest, {
    className: classnames('ln-c-card', className, (_classnames = {
      'ln-c-card--soft': !hard
    }, _classnames["ln-c-card--" + color] = color, _classnames['ln-c-card--rounded'] = rounded, _classnames))
  }), children);
};

Card.propTypes = {
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  hard: PropTypes.bool,
  color: PropTypes.string,
  rounded: PropTypes.bool
};
Card.defaultProps = {
  element: 'div',
  className: undefined,
  hard: false,
  color: undefined,
  rounded: false
};
Card.displayName = 'Card';

var colours = {
  success: 'green',
  info: 'blue',
  warning: 'amber',
  danger: 'red',
  none: 'transparent'
};

var StatusCard = function StatusCard(_ref) {
  var _classnames;

  var className = _ref.className,
      link = _ref.link,
      onClick = _ref.onClick,
      status = _ref.status,
      children = _ref.children,
      element = _ref.element,
      rest = _objectWithoutPropertiesLoose(_ref, ["className", "link", "onClick", "status", "children", "element"]);

  var cardEl = element;
  var props = Object.assign({}, rest, {
    className: classnames('ln-c-status-card', className, (_classnames = {
      'ln-c-status-card--link': link || onClick
    }, _classnames["ln-c-status-card--" + colours[status]] = colours[status], _classnames)),
    onClick: onClick
  });
  var body = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ln-c-status-card__content"
  }, children), (link || onClick) && /*#__PURE__*/React.createElement("div", {
    className: "ln-c-status-card__chevron"
  }, /*#__PURE__*/React.createElement(ArrowRight, null)));
  return React.isValidElement(cardEl) ? React.cloneElement(cardEl, props, body) : React.createElement(onClick ? 'button' : cardEl, props, body);
};

StatusCard.propTypes = {
  className: PropTypes.string,
  link: PropTypes.bool,
  onClick: PropTypes.func,
  status: PropTypes.oneOf(['success', 'info', 'warning', 'danger', 'none']),
  children: PropTypes.node.isRequired,
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
StatusCard.defaultProps = {
  className: undefined,
  link: false,
  onClick: undefined,
  status: undefined,
  element: 'div'
};
StatusCard.displayName = 'StatusCard';

export { Card, StatusCard };
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/card/dist/index.js
// module id = 209
// module chunks = 0